import React, { useRef } from "react";
import { Box, Button, Typography } from "@mui/material";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import EditIcon from "@mui/icons-material/Edit";

const GoalImageUpload = ({
  goalVideos,
  setGoalVideos,
  index,
}) => {
  const imageRef = useRef(null);

  const imageSrc =
    goalVideos[index]?.goal_image instanceof File
      ? URL.createObjectURL(goalVideos[index].goal_image)
      : goalVideos[index]?.goal_image;

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    setGoalVideos((prev) =>
      prev.map((item, i) =>
        i === index
          ? {
              ...item,
              goal_image: file,
              edited: true,
            }
          : item
      )
    );

    // Allows selecting the same file again
    e.target.value = "";
  };

  return (
    <Box>
      <Box className="upload-video">
        {imageSrc ? (
          <Box
            sx={{
              position: "relative",
              width: 80,
              height: 80,
              cursor: "pointer",
              "&:hover .image-overlay": {
                opacity: 1,
              },
            }}
            onClick={() => imageRef.current?.click()}
          >
            <Box
              component="img"
              src={imageSrc}
              alt="Goal"
              sx={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                objectFit: "cover",
                border: "1px solid #ddd",
              }}
            />

            <Box
              className="image-overlay"
              sx={{
                position: "absolute",
                inset: 0,
                borderRadius: "50%",
                backgroundColor: "rgba(0,0,0,0.45)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                opacity: 0,
                transition: "all 0.2s ease",
              }}
            >
              <EditIcon
                sx={{
                  color: "#fff",
                  fontSize: 24,
                }}
              />
            </Box>
          </Box>
        ) : (
          <Button
            className="upload-btn"
            onClick={() => imageRef.current?.click()}
            sx={{ color: "#ef364e" }}
          >
            <FileUploadIcon className="file-upload-icon" />
            <Typography>Upload Image</Typography>
          </Button>
        )}

        <input
          ref={imageRef}
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          onChange={handleImageChange}
        />
      </Box>
    </Box>
  );
};

export default GoalImageUpload;